import { render, staticRenderFns } from "./QuickTipsSplitId.vue?vue&type=template&id=96f8fe7c&scoped=true&"
import script from "./QuickTipsSplitId.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSplitId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f8fe7c",
  null
  
)

export default component.exports